import React from 'react'
import styled from 'styled-components'
import Theme from '../../../../vars/ThemeOptions'
import Img from 'gatsby-image'
import {Button, H3, P} from '../../../common'
 
const Wrap = styled.div`
  width: 100%;
  height: 30rem;
  position: relative;
  margin: 2rem auto -1rem auto;
  display: flex;
  flex-direction: column;
`

const ImageWrap = styled.div`
  width: 80%;
  height: 30rem;
  position: absolute;
  z-index: 0;
  left: 0;
  top: 0;
  .gatsby-image-wrapper {
    height: 100%;
    width: 100%;
  }
  @media only screen and (max-width: 991px) {
    width: 100%;
    height: 12rem;
    position: relative;
  }
`

const ContentWrap = styled.div`
  width: 45%;
  height: 20rem;
  position: absolute;
  z-index: 1;
  right: 5%;
  top: 5rem;
  padding: 2rem;
  background: ${Theme.hex('offWhite')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  a {
    background: ${Theme.hex('blue')};
    color: ${Theme.hex('white')};
    padding: .5rem 2rem;
  }
  @media only screen and (max-width: 991px) {
    width: 100%;
    height: 20rem;
    position: relative;
    right: 0;
    top: 0;
    background: ${Theme.hex('blue')};
    color: ${Theme.hex('white')};
    a {
      background: ${Theme.hex('white')};
      color: ${Theme.hex('blue')};
    }
  }
`
 
export const WideWithTextBox = ({ link }) => {
  // console.log("link: ",link)
  const { displayTitle, entry, subtext } = link;
  const { squareImage, slug } = entry ? entry : null;
  const { fluid } = squareImage ? squareImage : null;
  return (
    <Wrap>
      <ImageWrap>
        {fluid && <Img fluid={fluid} alt={squareImage.title} />}
      </ImageWrap>
      <ContentWrap>
        {displayTitle && <H3>{displayTitle}</H3>}
        {subtext && subtext.subtext && <P>{subtext.subtext}</P>}
        <br />
        {slug && <Button to={'/'+slug}>Learn More</Button>}
      </ContentWrap>
    </Wrap>
  )
}